import { render, staticRenderFns } from "./TransactionCustomsAccordion.vue?vue&type=template&id=1ecc5cd7"
import script from "./TransactionCustomsAccordion.vue?vue&type=script&lang=js"
export * from "./TransactionCustomsAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports